/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EligibilityCheckProviderInfo } from './EligibilityCheckProviderInfo';
import {
    EligibilityCheckProviderInfoFromJSON,
    EligibilityCheckProviderInfoFromJSONTyped,
    EligibilityCheckProviderInfoToJSON,
    EligibilityCheckProviderInfoToJSONTyped,
} from './EligibilityCheckProviderInfo';
import type { EligibilityRequestServiceTypeCodes } from './EligibilityRequestServiceTypeCodes';
import {
    EligibilityRequestServiceTypeCodesFromJSON,
    EligibilityRequestServiceTypeCodesFromJSONTyped,
    EligibilityRequestServiceTypeCodesToJSON,
    EligibilityRequestServiceTypeCodesToJSONTyped,
} from './EligibilityRequestServiceTypeCodes';
import type { EligibilityRequestAltParamsInner } from './EligibilityRequestAltParamsInner';
import {
    EligibilityRequestAltParamsInnerFromJSON,
    EligibilityRequestAltParamsInnerFromJSONTyped,
    EligibilityRequestAltParamsInnerToJSON,
    EligibilityRequestAltParamsInnerToJSONTyped,
} from './EligibilityRequestAltParamsInner';
import type { ServiceDates } from './ServiceDates';
import {
    ServiceDatesFromJSON,
    ServiceDatesFromJSONTyped,
    ServiceDatesToJSON,
    ServiceDatesToJSONTyped,
} from './ServiceDates';
import type { SubscriberInfo } from './SubscriberInfo';
import {
    SubscriberInfoFromJSON,
    SubscriberInfoFromJSONTyped,
    SubscriberInfoToJSON,
    SubscriberInfoToJSONTyped,
} from './SubscriberInfo';

/**
 * 
 * @export
 * @interface EligibilityCheckRequestObject
 */
export interface EligibilityCheckRequestObject {
    /**
     * 
     */
    provider?: EligibilityCheckProviderInfo;
    /**
     * 
     */
    subscriber?: SubscriberInfo;
    /**
     * 
     */
    serviceDates?: ServiceDates;
    /**
     * 
     */
    payerIdentifier?: string;
    /**
     * 
     */
    serviceTypeCodes?: EligibilityRequestServiceTypeCodes;
    /**
     * 
     */
    altParams?: Array<EligibilityRequestAltParamsInner>;
}

/**
 * Check if a given object implements the EligibilityCheckRequestObject interface.
 */
export function instanceOfEligibilityCheckRequestObject(value: object): value is EligibilityCheckRequestObject {
    return true;
}

export function EligibilityCheckRequestObjectFromJSON(json: any): EligibilityCheckRequestObject {
    return EligibilityCheckRequestObjectFromJSONTyped(json, false);
}

export function EligibilityCheckRequestObjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): EligibilityCheckRequestObject {
    if (json == null) {
        return json;
    }
    return {
        
        'provider': json['provider'] == null ? undefined : EligibilityCheckProviderInfoFromJSON(json['provider']),
        'subscriber': json['subscriber'] == null ? undefined : SubscriberInfoFromJSON(json['subscriber']),
        'serviceDates': json['serviceDates'] == null ? undefined : ServiceDatesFromJSON(json['serviceDates']),
        'payerIdentifier': json['payerIdentifier'] == null ? undefined : json['payerIdentifier'],
        'serviceTypeCodes': json['serviceTypeCodes'] == null ? undefined : EligibilityRequestServiceTypeCodesFromJSON(json['serviceTypeCodes']),
        'altParams': json['altParams'] == null ? undefined : ((json['altParams'] as Array<any>).map(EligibilityRequestAltParamsInnerFromJSON)),
    };
}

export function EligibilityCheckRequestObjectToJSON(json: any): EligibilityCheckRequestObject {
    return EligibilityCheckRequestObjectToJSONTyped(json, false);
}

export function EligibilityCheckRequestObjectToJSONTyped(value?: EligibilityCheckRequestObject | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'provider': EligibilityCheckProviderInfoToJSON(value['provider']),
        'subscriber': SubscriberInfoToJSON(value['subscriber']),
        'serviceDates': ServiceDatesToJSON(value['serviceDates']),
        'payerIdentifier': value['payerIdentifier'],
        'serviceTypeCodes': EligibilityRequestServiceTypeCodesToJSON(value['serviceTypeCodes']),
        'altParams': value['altParams'] == null ? undefined : ((value['altParams'] as Array<any>).map(EligibilityRequestAltParamsInnerToJSON)),
    };
}

